<kendo-dialog
  class="docusign-signing-dialog"
  [width]="960"
  [minWidth]="320"
  (close)="onClose()"
>
  <kendo-dialog-titlebar>
    <span class="text-truncate">{{ dialogTitle() }}</span>
  </kendo-dialog-titlebar>

  <div class="docusign-signing-body">
    @if (error(); as err) {
      <div class="docusign-signing-error" role="alert">{{ err }}</div>
      <div class="docusign-signing-actions">
        @if (canRetry() && retryAction(); as action) {
          <button
            kendoButton
            themeColor="primary"
            type="button"
            [help-anchor]="action.helpAnchor"
            (click)="retry()"
          >
            {{ action.label }}
          </button>
        }
        <button kendoButton type="button" (click)="onClose()">Close</button>
      </div>
    } @else {
      <div class="docusign-signing-frame">
        <!-- DocuSign.js mounts the focused-view ceremony into this element. -->
        <div #mount class="docusign-signing-mount"></div>
        @if (loading()) {
          <div class="docusign-signing-loading" aria-busy="true">
            <kendo-loader type="infinite-spinner" size="large" />
            <!-- Only the stage headline is live; the hint ticks every second and would be read out each time. -->
            <span class="docusign-signing-message" aria-live="polite">
              {{ stageMessage() }}
            </span>
            <span class="small docusign-signing-hint">{{ loadingHint() }}</span>
          </div>
        }
      </div>
    }
  </div>
</kendo-dialog>
